import React, { useEffect, useState } from "react";
import { GetCoupons } from "../../services/coupons/index.js";
import CouponTable from "../../components/Coupons/CouponTable";
import { Button, InlineStack, Text } from "@shopify/polaris";
import { useNavigate } from "react-router-dom";
import EmptyState from "../../components/Common/EmptyState.jsx";
import useBundlesStore from "../../store/bundle/index.js";
import { GetBundles } from "../../services/bundle/index.js";

const CouponDashboard = () => {
  const navigate = useNavigate();
  const [coupons, setCoupons] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const { bundles, setBundles } = useBundlesStore();

  const fetchCoupons = async () => {
    const { data } = await GetCoupons(currentPage);
    if (data.result) {
      setCoupons(data.result);
    }
  };
  const handleNavigate = (path) => {
    navigate(path);
  };

  const fetchBundles = async () => {
    if (!bundles.length) {
      const { data } = await GetBundles(currentPage);
      if (data?.result) {
        setBundles(data.result);
      }
    }
  };

  useEffect(() => {
    fetchCoupons();
    fetchBundles();
  }, []);
  return (
    <>
      {!coupons.length ? (
        <EmptyState
          heading={"No Deals Yet, No Biggie!"}
          text={
            "Create irresistible discounts and offers to delight your customers and boost your sales."
          }
          img="no coupon found.svg"
          btnName={"Create a coupon"}
          redirect={"/coupons/create"}
        />
      ) : (
        <>
          <InlineStack align="space-between">
            <Text variant="headingLg">Coupons</Text>
            <Button
              onClick={() => {
                handleNavigate("/coupons/create");
              }}
              variant="primary"
            >
              Create new Coupon
            </Button>
          </InlineStack>
          <br />
          <CouponTable
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            coupons={coupons}
            fetchCoupons={fetchCoupons}
          />
        </>
      )}
    </>
  );
};

export default CouponDashboard;
